module.exports = __webpack_public_path__ + "img/1.1ab88c30.png";